/**
 * 字典相关接口
 */

import request from "@/utils/request";

const apiRoute = "his-code"

// 获取用药频率
export function getFreq() {
    return request({
        url: "/freq/freq",
        method: "get"
    });
}
getFreq.prototype.name = "freq";

// 获取用药途径
export function getUsages(usagetype) {
    if (!usagetype) return new Promise(reject => reject())
    return request({
        url: `/${apiRoute}/usages/${usagetype}`,
        method: "get"
    })
}
getUsages.prototype.name = "usages";

// 获取医令单位
export function getUnits(ordertype) {
    return request({
        url: `/${apiRoute}/ge-units/${ordertype}`,
        method: "post"
    })
}
getUnits.prototype.name = "orderUnits";

// 加载证件类型
export function getIdType() {
    return request({
        url: `/${apiRoute}/id-type`,
        method: "get"
    })
}
getIdType.prototype.name = "idType";

// 加载职业
export function getJobType() {
    return request({
        url: `/${apiRoute}/job-type`,
        method: "get"
    })
}
getJobType.prototype.name = "job";

// 加载民族
export function getFolkType() {
    return request({
        url: `/${apiRoute}/folk-type`,
        method: "get"
    })
}
getFolkType.prototype.name = "folk";

// 加载病患来源
export function getPatientFromType() {
    return request({
        url: `/${apiRoute}/patient-from-type`,
        method: "get"
    })
}
getPatientFromType.prototype.name = "patientFrom";

// 加载来院方式
export function getComingWayType() {
    return request({
        url: `/${apiRoute}/coming-way-type`,
        method: "get"
    })
}
getComingWayType.prototype.name = "comingWay";

// 加载联系人关系
export function getRelationShipType() {
    return request({
        url: `/${apiRoute}/relation-ship-type`,
        method: "get"
    })
}
getRelationShipType.prototype.name = "relationship";

// 加载性别
export function getSexType() {
    return request({
        url: `/${apiRoute}/sex-type`,
        method: "get"
    })
}
getSexType.prototype.name = "sex";

// 加载婚姻情况
export function getMarriageType() {
    return request({
        url: `/${apiRoute}/marriage-type`,
        method: "get"
    })
}
getMarriageType.prototype.name = "marriage";

// 加载看诊身份
export function getMainIdentityType() {
    return request({
        // url: `/${apiRoute}/main-identity-type`, // 原查询所有
        url: `/${apiRoute}/sele-identity-type`, // 根据是否在客户端内查询
        method: "get"
    })
}
getMainIdentityType.prototype.name = "mainIdentity";

// 加载科室下拉列表（只加载启用的）
export function getSectionSelectList() {
    return new Promise((resolve, reject) => {
        request({
            url: "/section/option",
            method: "get"
        }).then(res => {
            res.data = res.data.filter(ev => ev.isTempStay === 0);
            resolve(res)
        }).catch((err) => {
            reject(err)
        })
    })
}
getSectionSelectList.prototype.name = "section";

// 加载科室下拉列表（加载全部）
export function getSectionSelectListAll() {
    return request({
        url: "/section/option",
        method: "get"
    })
}
getSectionSelectListAll.prototype.name = "sectionAll";

// 加载部位
export function getRegionType() {
    return request({
        url: `/${apiRoute}/region-type`,
        method: "get"
    })
}
getRegionType.prototype.name = "region";

// 表单类型
export function getSheetType() {
    return request({
        url: `/${apiRoute}/sheet-type`,
        method: "get"
    })
}
getSheetType.prototype.name = "sheet";

// 医令类型\类别
export function getOrderType() {
    return request({
        url: `/${apiRoute}/order-type`,
        method: "get"
    })
}
getOrderType.prototype.name = "orderType";

// 药品大分类
export function getOrderDrugType() {
    return request({
        url: `/${apiRoute}/order-drug-type`,
        method: "get"
    })
}
getOrderDrugType.prototype.name = "orderDrugType";

// 剂型大分类
export function getDrugMainformType() {
    return request({
        url: `/${apiRoute}/drug-mainform-type`,
        method: "get"
    })
}
getDrugMainformType.prototype.name = "drugMainformType";

// 剂型子分类
export function getDrugFormType(code) {
    return request({
        url: `/${apiRoute}/drug-form-type?code=${code}`,
        method: "get"
    })
}
getDrugFormType.prototype.name = "drugFormType";

// 药理分类
export function getPharmacologyType() {
    return request({
        url: `/${apiRoute}/pharmacology-type`,
        method: "get"
    })
}
getPharmacologyType.prototype.name = "pharmacologyType";

// 抗菌药物级别
export function getAntibioticLevelType() {
    return request({
        url: `/${apiRoute}/antibiotic-level-type`,
        method: "get"
    })
}
getAntibioticLevelType.prototype.name = "antibioticLevelType";

// 限制类别
export function getDrugLimitType() {
    return request({
        url: `/${apiRoute}/drug-limit-type`,
        method: "get"
    })
}
getDrugLimitType.prototype.name = "drugLimitType";

// 拆单方式
export function getSeparateType() {
    return request({
        url: `/${apiRoute}/separate-sheet-type`,
        method: "get"
    })
}
getSeparateType.prototype.name = "separateType";

// 获取看诊级别
export function getDoctorLevelList() {
    return request({
        // url: "/doctor-level/option",
        url: "/doctor-level/option-not-null",
        method: "get",
    })
};
getDoctorLevelList.prototype.name = "doctorLevel";

// 获取诊室/诊间下拉
export function getRoomOption(parmas) {
    return request({
        url: "/room/room-option",
        method: "get",
        parmas
    })
}
getRoomOption.prototype.name = "roomOption";

// 加载职务类型
export function getUserJobType() {
    return request({
        url: `/${apiRoute}/user-job-type`,
        method: "get"
    })
}
getUserJobType.prototype.name = "userJob";

// 加载职称类型
export function getPositionalType() {
    return request({
        url: `/${apiRoute}/positional-titles-type`,
        method: "get"
    })
}
getPositionalType.prototype.name = "positionalType";

// 获取医生下拉
export function getDoctorOption(id) {
    return request({
        url: `/user-info/doctor-option/${id}`,
        method: "get"
    })
}
getDoctorOption.prototype.name = "doctorOption";

// 加载检体类型
export function getSpecimenType() {
    return request({
        url: `/${apiRoute}/specimen-type`,
        method: "get"
    })
}
getSpecimenType.prototype.name = "specimen";

// 加载处方类型
export function getReportType() {
    return request({
        url: `/${apiRoute}/report-type`,
        method: "get"
    })
}
getReportType.prototype.name = "report";

// 加载挂号途径
export function getRegistrationWayType() {
    return request({
        url: `/${apiRoute}/register-channel-type`,
        method: "get"
    })
}
getRegistrationWayType.prototype.name = "registrationWay";

// 退号原因
export function getCancelReasonType() {
    return request({
        url: `/${apiRoute}/cancel-reason-type`,
        method: "get"
    })
}
getCancelReasonType.prototype.name = "cancelReason";

// 退费原因
export function getRefundsType() {
    return request({
        url: `/${apiRoute}/refunds-type`,
        method: "get"
    })
}
getRefundsType.prototype.name = "refundsType";

// 挂号类别
export function getVisitType() {
    return request({
        url: `/${apiRoute}/visit-type`,
        method: "get"
    })
}
getVisitType.prototype.name = "visitType";

// 看诊状态
export function getPatientVisitType() {
    return request({
        url: `/${apiRoute}/patient-visit-type`,
        method: "get"
    })
}
getPatientVisitType.prototype.name = "patientVisitType";

// 收据类别
export function getReceiptType() {
    return request({
        url: `/${apiRoute}/receipt-type`,
        method: "get"
    })
}
getReceiptType.prototype.name = "receiptType";

// 账单类别
export function getOpdBillType() {
    return request({
        url: `/${apiRoute}/opd-bill-type`,
        method: "get"
    })
}
getOpdBillType.prototype.name = "opdBillType";

// 排班预约间隔时间
export function getTimeinterval() {
    return new Promise(resolve => {
        resolve({
            data: {
                items: [
                    { value: 5, label: "5" },
                    { value: 10, label: "10" },
                    { value: 15, label: "15" },
                    { value: 20, label: "20" },
                    { value: 30, label: "30" },
                    { value: 60, label: "60" },
                ]
            }
        })
    })
}
getTimeinterval.prototype.name = "timeinterval";

// 盘点作业状态
export function getInventoryStatusType() {
    return request({
        url: `/${apiRoute}/inventory-status-type`,
        method: "get"
    })
}
getInventoryStatusType.prototype.name = "inventoryStatusType";

// 入库类型（全部）
export function getInStorageType() {
    return request({
        url: `/${apiRoute}/in-storage-type`,
        method: "get"
    })
}
getInStorageType.prototype.name = "inStorageType";

// 出库类型（全部）
export function getOutStorageType() {
    return request({
        url: `/${apiRoute}/out-storage-type`,
        method: "get"
    })
}
getOutStorageType.prototype.name = "outStorageType";

// 入库类型（入库）
export function getInStoragePartType() {
    return request({
        url: `/${apiRoute}/part-in-storage-type`,
        method: "get"
    })
}
getInStoragePartType.prototype.name = "inStoragePartType";

// 出库类型（出库）
export function getOutStoragePartType() {
    return request({
        url: `/${apiRoute}/part-out-storage-type`,
        method: "get"
    })
}
getOutStoragePartType.prototype.name = "outStoragePartType";

// 入库类型（实时库存）
export function getInStoragePartRealTimeType() {
    return request({
        url: `/${apiRoute}/part-in-storage-type-real-time`,
        method: "get"
    })
}
getInStoragePartRealTimeType.prototype.name = "inStoragePartRealTimeType";

// 出库类型（实时库存）
export function getOutStoragePartRealTimeType() {
    return request({
        url: `/${apiRoute}/part-out-storage-type-real-time`,
        method: "get"
    })
}
getOutStoragePartRealTimeType.prototype.name = "outStoragePartRealTimeType";

// 获取诊断类型
export function getDiseaseType() {
    return request({
        url: `/${apiRoute}/disease-medical-type`,
        method: "get"
    })
}
getDiseaseType.prototype.name = "diseaseType";

// 加载中药煎法
export function getDecoctionMethodType() {
    return request({
        url: `/${apiRoute}/decoctions`,
        method: "get"
    })
}
getDecoctionMethodType.prototype.name = "decoction";

// 加载药品大分类(盘点)
export function getOrderDrugTypeNew() {
    return request({
        url: `/${apiRoute}/order-drug-type-new`,
        method: "get"
    })
}
getOrderDrugTypeNew.prototype.name = "orderDrugTypeNew";

// 加载会员退费原因
export function getRefundReason() {
    return request({
        url: `/${apiRoute}/member-refunds-type`,
        method: "get"
    })
}
getRefundReason.prototype.name = "refundReason";

// 获取代加工医令
export function getProcessList() {
    return request({
        url: `/opd-input-order/process-list`,
        method: "get"
    })
}
getProcessList.prototype.name = "process";

// 记载发票类型 
export function getInvoiceType() {
    return request({
        url: `/${apiRoute}/invoice-type`,
        method: "get"
    })
}
getInvoiceType.prototype.name = "invoiceType";

// 获取全部人员
export function getUserALl() {
    return request({
        url: `/user-info/user-all`,
        method: "post"
    })
}
getUserALl.prototype.name = "userAll";

//  加载LIS性别
export function getLisSexType() {
    return request({
        url: `/${apiRoute}/lis-sex-type`,
        method: "get"
    })
}
getLisSexType.prototype.name = "lisSexType";

//  加载LIS年龄类型
export function getAgeUnuitType() {
    return request({
        url: `/${apiRoute}/age-unuit-type`,
        method: "get"
    })
}
getAgeUnuitType.prototype.name = "ageUnuitType";

//  加载LIS阴性阳性弱阳性
export function getLisSkinTestType() {
    return request({
        url: `/${apiRoute}/lis-skin-test-type`,
        method: "get"
    })
}
getLisSkinTestType.prototype.name = "lisSkinTestType";

// 加载仪器类型
export function getInstrumentType() {
    return request({
        url: `/lis-machine/lis-workgroup-list-option`,
        method: "get"
    })
}
getInstrumentType.prototype.name = "instrument"

// 加载检查类型 
export function getInspectionType() {
    return request({
        url: `/lis-report/lis-inspection-list`,
        method: "get"
    })
}
getInspectionType.prototype.name = "inspectionType"

// 加载Lis检体类型
export function getLisSpecimenType() {
    return request({
        url: `/${apiRoute}/lis-specimen-type`,
        method: "get"
    })
}
getLisSpecimenType.prototype.name = "lisSpecimen";

// 获取生产厂家50条
export function getManufacturers(querytext) {
    return request({
        url: `/his-code/manufacturers?querytext=${querytext}`,
        method: "get"
    })
}
getManufacturers.prototype.name = "manufacturers";

// 获取汇率列表
export function getMonetaryRateList() {
    return request({
        url: `/his-config/monetary-rate-list`,
        method: 'get'
    })
}
getMonetaryRateList.prototype.name = "monetaryRate";

// 获取汇率信息带本国货币
export function getMonetaryRateWithBasicList() {
    return request({
        url: `/his-config/monetary-rate-info-list-with-basic`,
        method: 'get'
    })
}
getMonetaryRateWithBasicList.prototype.name = "monetaryRateBasic";

// 入院病危等级
export function getRegisterGradesType() {
    return request({
        url: "/his-code/register-grades-type",
        method: 'get'
    })
}
getRegisterGradesType.prototype.name = "gradesType";

// 病区
export function getInpatientWardList() {
    return request({
        url: "/his-code/inpatient-ward-list",
        method: 'get'
    })
}
getInpatientWardList.prototype.name = "ward";

// 病床位置
export function getBedPlaceList() {
    return request({
        url: '/his-code/bed-place-list',
        method: 'get'
    })
}
getBedPlaceList.prototype.name = "bedPlace";  

//  加载费用计算方法  
export function getCostCalculationMethodType() {
    return request({
        url: '/his-code/cost-calculation-method-type',
        method: 'get'
    })
}
getCostCalculationMethodType.prototype.name = "costCalculationMethodType"; 

// 药房下拉（不限）
export function getWareHouseList() {
    return request({
        url: '/room/warehouse-room-option-by-type/1',
        method: 'get'
    })
}
getWareHouseList.prototype.name = "wareHouseAll";

// 药房下拉（住院）
export function getInWareHouseList() {
    return request({
        url: '/room/warehouse-room-option-by-type/3',
        method: 'get'
    })
}
getInWareHouseList.prototype.name = "wareHouseIn";

// 药房下拉（门诊）
export function getOutWareHouseList() {
    return request({
        url: '/room/warehouse-room-option-by-type/2',
        method: 'get'
    })
}
getOutWareHouseList.prototype.name = "wareHouseOut";

// 获取发药医嘱类型
export function getMedicineDoctorAdviceType() {
    return request({
        url: '/his-code/medicine-doctor-advice-type',
        method: 'get'
    })
}
getMedicineDoctorAdviceType.prototype.name = "medicineDoctorAdviceType";

// 获取发药医嘱类型\住院状态
export function getInpatientStatusType() {
    return request({
        url: '/his-code/inpatient-status-type',
        method: 'get'
    })
}
getInpatientStatusType.prototype.name = "inpatientStatusType";
